/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function (define) {
  'use strict';

  define(function () {
    /**
     * Custom error type for promises rejected by promise.timeout
     * @param {string} message
     * @constructor
     */
    function TimeoutError(message) {
      Error.call(this);
      this.message = message;
      this.name = TimeoutError.name;
      if (typeof Error.captureStackTrace === 'function') {
        Error.captureStackTrace(this, TimeoutError);
      }
    }
    TimeoutError.prototype = Object.create(Error.prototype);
    TimeoutError.prototype.constructor = TimeoutError;
    return TimeoutError;
  });
})(typeof define === 'function' && define.amd ? define : function (factory) {
  module.exports = factory();
});